/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DeleteModal/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function DeleteModal({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/TaskInsertNew/Tags/Content/SearchResult/Content/Tag/DeleteModal"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}